<i18n lang="yaml">
zh:
  story_element: "故事要素"
  version: "版本"
  generate_element: "生成要素"
  regenerate: "重新生成"
  generate_outline: "生成大纲"
  next_step: "下一步"
  input_story_element: "请输入故事要素"
  story_background: "故事背景"
  worldview: "世界观"
  story_mainline: "故事主线"
  emotion_line: "情感线"
  character_setting: "人设"
  story_element_missing: "故事要素丢失"
en:
  story_element: "Story Element"
  version: "Version"
  generate_element: "Generate Element"
  regenerate: "Regenerate"
  generate_outline: "Generate Outline"
  next_step: "Next Step"
  input_story_element: "Please enter the story element"
  story_background: "Story Background"
  worldview: "Worldview"
  story_mainline: "Story Mainline"
  emotion_line: "Emotion Line"
  character_setting: "Character Setting"
  story_element_missing: "Story element missing"
</i18n>
<template>
  <div class="writer-box writer-bg">
    <HeadNavWriter ref="headeNvWriterRef"/>

    <div class="writer-box-content">

      <!-- steps -->
      <StepsWriter :active="1"/>

      <!-- elements -->
      <div class="hidden-xs-only" style="font-weight: 600; font-size: 20px; color: #000000; line-height: 24px;margin: 1rem 0;">
        {{$t('story_element')}}
      </div>
      <div class="writer-box-content-editor">
<!--
          @cut.native="changeInput"
          @paste.native="changeInput" -->
        <el-input
          @input="changeInput"
          v-if="!isSkeleton" :disabled="!storyElement&&!story.storyElementId" class="writer-box-input global-box-scrollbar" id="msgbox" type="textarea" v-model="storyElement" show-word-limit></el-input>
        <LlmSkeleton v-else />
      </div>

    </div>

    <!-- footer -->
    <div class="writer-box-footer" :class="{'button-flex-between': story.articleGenType != 'GEN_BY_OUTLINE'}">
      <span v-show="story.articleGenType != 'GEN_BY_OUTLINE' && storyElements.length==0"></span>
      <span v-show="story.articleGenType != 'GEN_BY_OUTLINE' && storyElements.length>0">
        <el-select class="custom-select"
            v-model="story.storyElementId"
            filterable
            size="mini"
            :disabled="isLoading"
            :placeholder="$t('version')">
          <el-option
            v-for="itemVersion in storyElements"
            @click.native.stop="contentChange(itemVersion)"
            :key="itemVersion.id"
            :label="$t('version') + ' ' + itemVersion.version"
            :value="itemVersion.id"
          />
        </el-select>
      </span>
      <span class="button-group">
        <el-button class="custom-button" :size="$root.buttonSize" type="primary" round @click="genStoryElement()" :loading="isLoading" :disabled="isLoading" v-if="story.articleGenType != 'GEN_BY_OUTLINE' && storyElements.length==0">{{$t('generate_element')}}</el-button>
        <el-button class="custom-button" :size="$root.buttonSize" type="default" round icon="el-icon-refresh" @click="handleSave(1)" :loading="isLoading" :disabled="isLoading" v-if="story.articleGenType != 'GEN_BY_OUTLINE' && storyElements.length>0">{{$t('regenerate')}}</el-button>
        <el-button class="custom-button" :size="$root.buttonSize" type="primary" @click="handleSave(2)" :disabled="isLoading" v-if="story.articleGenType != 'GEN_BY_OUTLINE' && storyElements.length>0">{{$t('generate_outline')}}</el-button>
        <el-button class="custom-button" :size="$root.buttonSize" type="primary" @click="handleSave(0)" :disabled="isLoading" v-if="story.articleGenType == 'GEN_BY_OUTLINE' && storyElements.length>0">{{$t('next_step')}}</el-button>
      </span>
    </div>
  </div>
</template>
<script>
import HeadNavWriter from '@/components/HeadNavWriter'
import StepsWriter from '@/components/StepsWriterZhihu'
import LlmSkeleton from '@/components/LlmSkeleton'
import * as EnumApi from '@/api/enums'
import * as ArticleApi from '@/api/article'
import * as StoryElementApi from '@/api/storyelement'
import * as StoryOutlineApi from '@/api/storyoutline'
import * as StoryTemplateQuestionApi from '@/api/storytemplatequestion'
import { mapState, mapMutations} from 'vuex'
import sse from '@/utils/llmstream'
export default {
  name: 'Article',
  components: {
    LlmSkeleton, HeadNavWriter, StepsWriter
  },
  data() {
    return {
      checked4ElementVersion: false,
      enums: {},
      isLoading: false,
      isSkeleton: false,
    	autoRunedFlag: false,
      storyElement: '',
      // storyElements: [{id: '0', content: '', version: 1}],
      storyElements: [],
      storyElementTemplate: `### {{$t('story_background')}}：

### {{$t('worldview')}}：

### {{$t('story_mainline')}}：

### {{$t('emotion_line')}}：

### {{$t('character_setting')}}：

`
    }
  },
  computed: {
  	...mapState(['user', 'story', 'dialogShowCostomContactFlag'])
  },
  mounted() {

    // console.log('story', this.story)
    this.handleEnum()
    this.handlePageStoryElementVersion()
    // this.handleViewStory()
  },
  methods: {
    ...mapMutations(['setStory', 'setShowDialogDpFlag', 'setDialogShowCostomContactFlag']),
    formatStoryElementContent(content) {
      if (!content) {
        return ''
      }
      const labels = [
        '时代标签', '故事背景', '中心思想', '角色定位',
        '拥有的心理或精神疾病', '拥有的身体疾病',
        '行为特征', '故事主线', '情感线',
        '时代', '类型', '标签', '世界观',
        '姓名', '性别', '身份', '年龄', '外貌',
        '性格', '目标', '动机', '金手指', '三观',
        '人物经历', '冲突亮点', '爽点', '看点'
      ].sort((a, b) => b.length - a.length)
      const labelPattern = labels.join('|')
      return content
        .replace(/\r\n?/g, '\n')
        .replace(/\\n/g, '\n')
        .replace(/\*\*/g, '')
        .replace(/([^#\n])\s*(#{2,6}\s*)/g, '$1\n\n$2')
        .replace(new RegExp('([^\\n])\\s*((' + labelPattern + ')[：:])', 'g'), '$1\n$2')
        .replace(/([^\n])\s*((?:喜欢上|和|与)?【[^】]{1,20}】的(?:关系|原因|矛盾原因|矛盾结果)[：:])/g, '$1\n$2')
        .replace(/([：:。；;])\s*((?:[1-9]|1[0-9])(?:[、)）]|[.．](?!\d))\s*)/g, '$1\n$2')
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim()
    },
    applyStoryElementContent(content) {
      const formattedContent = this.formatStoryElementContent(content)
      this.storyElement = formattedContent
      this.story.storyElement = formattedContent
      this.setStory(this.story)
      return formattedContent
    },
    contentChange(item){
      // console.log('contentChange', item.content);
      this.story.storyElementId = item.id
      const formattedContent = this.applyStoryElementContent(item.content)
      item.content = formattedContent
      this.handleUpdateStory(item)
    },
    changeInput(event){
      // console.log('changeInput', event);
      this.handleUpdateElement()
    },
    replaceLineBreaks(str) {
      return str?str.replace(/\\n/g, '\n').replace(/\n/g, '<br>'):"";
    },
    handleUpdateStory(item) {
      ArticleApi.update({id: this.story.id,
          storyElementId: item.id,
          storyElement: item.content}
      ).then(res => {

      });
    },
    handleUpdateElement() {
      if(this.isLoading){// 正在生成内容
        return false;
      }
      if(!this.story.storyElementId || this.story.storyElementId == 0){
        return false
      }
      this.story.storyElement = this.storyElement
      this.setStory(this.story)
      StoryElementApi.update({id: this.story.storyElementId,
          content: this.storyElement}
      ).then(res => {
        // 更新this.storyElements = [];
        this.storyElements.forEach((item,index)=>{
          if(this.story.storyElementId == item.id){
            item.content = this.storyElement
          }
        })
      });
    },
    handlePageStoryElementVersion(flag){
      StoryElementApi.page({storyId: this.story.id, size: 100}).then(res => {
        let result = res.data.data;
        if(res.data.code == 0){
          if(result.records.length > 0){
            this.storyElements = result.records.map(item => {
              item.content = this.formatStoryElementContent(item.content)
              return item
            });
            let currentElement = this.storyElements.filter(i=>{return i.id==this.story.storyElementId})[0];
            if(currentElement){
              this.storyElement = this.formatStoryElementContent(currentElement.content)
              this.story.storyElementId = currentElement.id
            }else{
              this.story.storyElementId = this.storyElements[result.records.length-1].id
              this.storyElement = this.storyElements[result.records.length-1].content
            }
          }else{
            this.storyElements = []
          }
          this.applyStoryElementContent(this.storyElement)
          console.log('handlePageStoryElementVersion', this.story);
          if(result.records.length == 0){// 从创意开始，自动生成要素
            if(this.user.desktopFlag && !this.autoRunedFlag){
              this.autoRunedFlag = true
              this.genStoryElement()
            }
          }
          if(flag && flag == 3 && result.records.length>0){// 自动生成标题
            this.genStoryTitle()
            this.contentChange(this.storyElements[this.storyElements.length-1])
          }
        }
      })
    },
    handleEnum() {
      EnumApi.list().then(res => {
        let result = res.data.data;
        this.enums = result
      })
    },
    handleViewStory() {
      ArticleApi.view(this.story.id).then(res => {
        if(res.data.code == 0){
          console.log('handleViewStory', res.data.data)
          this.setStory(res.data.data)
        }
      })
    },
    handleSave(flag) {
      if(flag == 0){//by outline 下一步
        const storyElement = this.formatStoryElementContent(this.storyElement)
        if (!storyElement || !storyElement.trim() || storyElement == this.storyElementTemplate) {
            this.$message.error(this.$t('input_story_element'));
            return false;
        }
        StoryElementApi.create({storyId: this.story.id, content: storyElement}).then(res => {
            this.applyStoryElementContent(storyElement)
            console.log('handleSave')
            this.story.stepNumber = 2
            this.setStory(this.story)
            this.genStoryTitle()
            this.$router.push('/workspace/gen2');
        })
      }else if(flag == 1){// by idea : 重新生成 弹窗
        // this.story.reCreate = true
        // this.setStory(this.story)
        // this.setShowDialogDpFlag(true)
        this.genStoryElement()
      }else if(flag == 2){// by idea : 下一步
        const storyElement = this.formatStoryElementContent(this.storyElement)
        if (!storyElement || !storyElement.trim() || storyElement == this.storyElementTemplate) {
            this.$message.error(this.$t('input_story_element'));
            return false;
        }
        this.applyStoryElementContent(storyElement)
        console.log('handleSave flag=1')

        if(this.story.stepNumber<2){
          this.story.stepNumber = 2
          this.setStory(this.story)
        }

        setTimeout(()=>{
          this.$router.push('/workspace/gen2');
        },300)
      }else if(flag == 3){//by idea AI 生成完之后保存版本
        if(this.story.stepNumber<2){
          this.story.stepNumber = 2
          this.setStory(this.story)
        }
        this.handlePageStoryElementVersion(3)
      }
    },
    handleBlur() {
      // this.handleSave();
    },
    scrollToBottom() {
      const msgbox = document.getElementById("msgbox")
      msgbox.scrollTop = msgbox.scrollHeight;
    },
    genStoryTitle() {
        console.log('story::title', this.story);
        if (this.story.title) {
            return false;
        }
        if (!this.story.storyElement) {
            // this.$message.error('故事要素丢失');
            return false;
        }
        let params = Object.assign({}, this.story)
        params.articleId = this.story.id
        params.storyElement = this.story.storyElement
        params.platformCategory = 'WRITER_WEB'

        sse("1806516321777786881", params, this.handleStoryTitleMsg).then((result)=>{
        // sse("1843352229667602433", params, this.handleStoryTitleMsg).then((result)=>{//v1.5
          // console.log('result', result);
          //AI结束，处理逻辑
          this.story.title = result.replace(/<[^>]*>?/gm, '');
          this.setStory(this.story)
          this.$refs.headeNvWriterRef.syncUser()
        }).catch(error => {
          // 处理错误
          console.error(error);
        });
    },
    handleStoryTitleMsg(msg){
      // console.log('title', msg);
    },
    handleStoryElementMsg(msg){
      // console.log('element', msg);
      this.isSkeleton = false;
      this.storyElement = this.formatStoryElementContent(msg)
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    genStoryElement() {
        console.log('story::element', this.story);
        this.isLoading = true;
        this.isSkeleton = true;
        const previousStoryElement = this.storyElement || this.story.storyElement || ''
        this.storyElement = ''
        let params = Object.assign({}, this.story)
        params.articleId = this.story.id
        params.content = this.story.storyIdea
        params.platformCategory = 'WRITER_WEB'

        // 知乎短篇-生成要素
        //8月28 使用要素模板 自由模式
        let workflowId = "1828713703923752961";
        // 模板模式
        if(this.story.storyTemplateId && this.story.storyTemplateId != '0'){
          // workflowId = "1828785099852935170";
          workflowId = "1843352229667602433";//v1.5
          // 获取当前用户的QA列表（故事梗概)
          let templateId = this.story.storyTemplateId
          StoryTemplateQuestionApi.page({templateId, storyId:this.story.id, accountId:this.user.id,shortcutFlag: this.story.newFlag, size: 20}).then(res => {
            let result = res.data.data;
            let storyTemplateQuestions = result.records

            let history = []
            storyTemplateQuestions.forEach((item,index) => {
              if(item.answerVo && item.answerVo.answer){
                history.push('Q'+(index+1)+':'+item.title)
                history.push('A'+(index+1)+':'+item.answerVo.answer)
                if(this.story.newFlag){
                  params.content = item.answerVo.storyContentRequired
                }
              }else{
                history.push('Q'+(index+1)+':'+item.title)
                history.push('A'+(index+1)+':')
              }
            })
            console.log('findQaHistory ', history);
            params.storyQaHistory = history.join('\n')
            sse(workflowId, params, this.handleStoryElementMsg).then((result)=>{
              // console.log('genStoryElement sse', result);
              //AI结束，处理逻辑
              this.isLoading = false;
              this.isSkeleton = false;
              this.applyStoryElementContent(result)
              // 保存版本
              this.handleSave(3)
              this.$refs.headeNvWriterRef.syncUser()
            }).catch(error => {
              // 处理错误
              console.error(error);
              let currentElement = this.storyElements.filter(i=>{return i.id==this.story.storyElementId})[0];
              const fallbackContent = this.storyElement || (currentElement && currentElement.content) || previousStoryElement
              if(fallbackContent){
                this.applyStoryElementContent(fallbackContent)
              }
              this.isLoading = false;
              this.isSkeleton = false;
            })
          });
        }else{
          sse(workflowId, params, this.handleStoryElementMsg).then((result)=>{
            // console.log('genStoryElement sse', result);
            //AI结束，处理逻辑
            this.isLoading = false;
            this.isSkeleton = false;
            this.applyStoryElementContent(result)
            // 保存版本
            this.handleSave(3)
            this.$refs.headeNvWriterRef.syncUser()
          }).catch(error => {
            // 处理错误
            console.error(error);
            let currentElement = this.storyElements.filter(i=>{return i.id==this.story.storyElementId})[0];
            const fallbackContent = this.storyElement || (currentElement && currentElement.content) || previousStoryElement
            if(fallbackContent){
              this.applyStoryElementContent(fallbackContent)
            }
            this.isLoading = false;
            this.isSkeleton = false;
          })
        }
    }
  }
}
</script>
<style scoped lang="scss">

</style>
